export const parseNumber = (value: string): Number | null => {
  if (!value.replace(/\s/g, '').length || value === null || value === undefined) {
    return null
  }
  return parseFloat(value.replace(/,/g, ''))
}
